import { Popover as AntPopover } from 'antd';
import styled from 'styled-components';

export const Popover = styled(AntPopover)``;
